import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Dashboard from "pages/Dashboard";

export const AppRouter: React.FC = () => (
  <Switch>
    <Route path="/esign/overview" exact component={Dashboard} />
    <Route path="*">
      <Redirect to="/esign/overview" />
    </Route>
  </Switch>
);

export default AppRouter;
